import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, ActivationEnd, Router } from '@angular/router';
import { EnvironmentService } from '@galaxy/core';
import { BrandingV2Service } from '@galaxy/partner';
import { BehaviorSubject, Observable } from 'rxjs';
import { filter, map, take } from 'rxjs/operators';
import { StyleConfigService } from './services/style-config/style-config.service';

@Injectable({
  providedIn: 'root',
})
export class StorefrontService {
  private _partnerId$$ = new BehaviorSubject<string>(undefined);
  private _marketId$$ = new BehaviorSubject<string>(undefined);
  private _packageId$$ = new BehaviorSubject<string>(undefined);
  private _logoURL$$ = new BehaviorSubject<string>(undefined);
  private _showTopBar$$ = new BehaviorSubject<boolean>(undefined);
  private _hideSignIn$$ = new BehaviorSubject<boolean>(undefined);

  private _partnerId$ = this._partnerId$$.asObservable();
  private _marketId$ = this._marketId$$.asObservable();
  private _packageId$ = this._packageId$$.asObservable();
  private _logoURL$ = this._logoURL$$.asObservable();
  private _showTopBar$ = this._showTopBar$$.asObservable();
  private _hideSignIn$ = this._hideSignIn$$.asObservable();

  constructor(
    private router: Router,
    private httpService: HttpClient,
    private environmentService: EnvironmentService,
    private styleConfigService: StyleConfigService,
    private brandingService: BrandingV2Service,
  ) {
    this.initializeObservables();
  }

  initializeObservables(): void {
    this.router.events
      .pipe(
        filter((e) => e instanceof ActivationEnd && Object.keys(e.snapshot.params).length > 0),
        map((e) => (e instanceof ActivationEnd ? e.snapshot : {})),
      )
      .subscribe((snapshot: ActivatedRouteSnapshot) => {
        this.styleConfigService.setQueryParams(snapshot.queryParamMap);
        this._marketId$$.next(snapshot.params.marketId);
        this._partnerId$$.next(snapshot.params.partnerId);
        this._packageId$$.next(snapshot.params.packageId);
        if (this._showTopBar$$.getValue() === undefined) {
          this._showTopBar$$.next(snapshot.queryParamMap.get('hide') !== 'topbar');
        }
        if (this._hideSignIn$$.getValue() === undefined) {
          this._hideSignIn$$.next(snapshot.queryParamMap.get('hide') === 'signin');
        }
      });
  }

  setPartnerLogoImage(partnerId: string, marketId: string): void {
    // normalize
    marketId = marketId ? marketId : 'default';

    this.brandingService
      .getBranding(partnerId, marketId)
      .pipe(take(1))
      .subscribe((data) => {
        this._logoURL$$.next(data.logoUrl);
      });
  }

  get partnerId$(): Observable<string> {
    return this._partnerId$;
  }

  get marketId$(): Observable<string> {
    return this._marketId$;
  }

  get packageId$(): Observable<string> {
    return this._packageId$;
  }

  get logoURL$(): Observable<string> {
    return this._logoURL$;
  }

  get showTopBar$(): Observable<boolean> {
    return this._showTopBar$;
  }

  get hideSignIn$(): Observable<boolean> {
    return this._hideSignIn$;
  }
}
